/*
 * ---------------------------------------------------------------------
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 WALC Inc. Inc. All Rights Reserved.
 *
 * file=credentials-interceptor.ts
 *
 * This software is the confidential and proprietary information of WALC Inc.
 * (Confidential Information). You shall not disclose such Confidential Information
 * and shall use it only in accordance with the terms of the license agreement
 * you entered into with WALC Inc.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * <summary>: すべての HTTP リクエストで Cookie と認証ヘッダーを送るインターセプター。
 * ---------------------------------------------------------------------
 */


import { HttpInterceptorFn } from '@angular/common/http';

// Cookie/認証ヘッダーを自動送信する（本番は BFF、ローカルは proxy 経由）。
export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req.clone({ withCredentials: true }));
};
